/* ============================================================
   ATLAS UI STATES — FOUNDATION
   ------------------------------------------------------------
   SCOPO:
   - Centralizzare lo stato UI globale del widget ATLAS
   - Fornire un’unica fonte di verità per lo stato visivo
   - Notificare i cambi di stato tramite eventi custom

   FILOSOFIA:
   - Questo modulo NON fa UI
   - NON manipola il DOM
   - NON prende decisioni applicative
   - Espone solo stato + eventi

   Altri moduli:
   - impostano lo stato (core, watchdog, ecc.)
   - reagiscono allo stato (listener, overlay, CSS)
============================================================ */
;(function () {
  'use strict';

  /* ============================
     UI NAMESPACE INIT
  ============================ */

  if (!window.ATLAS) window.ATLAS = {};
  if (!window.ATLAS.ui) window.ATLAS.ui = {};

  const UI = window.ATLAS.ui;

  /* ============================
     STATE DEFINITION
  ============================ */

  // Stato UI corrente (single source of truth)
  let currentState = 'idle';

  // Stati consentiti
  const STATES = Object.freeze({
    IDLE: 'idle',
    LOADING: 'loading',
    LISTENING: 'listening',
    THINKING: 'thinking',
    OFFLINE: 'offline',
    ERROR: 'error'
  });

  /* ============================
     FEATURE FLAGS (URL-BASED)
     es: ?wow=1
  ============================ */

  const params = new URLSearchParams(window.location.search);
  const wowEnabled = params.get('wow') === '1';

  window.ATLAS.flags = window.ATLAS.flags || {};
  window.ATLAS.flags.wow = wowEnabled;

  if (window.__ATLAS_DEBUG__) {
    console.log('[ATLAS] WOW flag:', wowEnabled ? 'ON' : 'OFF');
  }

  /* ============================
     UI STATES API
  ============================ */

  UI.states = {
    STATES,

    /**
     * Ritorna lo stato UI corrente
     */
    get() {
      return currentState;
    },

    /**
     * Verifica se lo stato corrente coincide
     */
    is(state) {
      return currentState === state;
    },

    /**
     * Imposta un nuovo stato UI
     * - valida lo stato
     * - evita transizioni inutili
     * - emette evento globale
     */
    set(nextState, meta = {}) {
      if (!Object.values(STATES).includes(nextState)) {
        console.warn('[ATLAS][UI] Stato non valido:', nextState);
        return;
      }

      if (nextState === currentState) return;

      const prev = currentState;
      currentState = nextState;

      try {
        window.dispatchEvent(
          new CustomEvent('atlas:ui:state', {
            detail: { from: prev, to: nextState, meta }
          })
        );
      } catch (e) {
        console.warn('[ATLAS][UI] Event dispatch failed', e);
      }
    }
  };

})();

/* ============================================================
   ATLAS UI — STATE → DOM LISTENER
   ------------------------------------------------------------
   Responsabilità:
   - Tradurre lo stato UI in classi CSS sul <body>
   - ZERO logica decisionale
============================================================ */

(function () {
  'use strict';

  window.addEventListener('atlas:ui:state', function (e) {
    const state = e.detail?.to;
    if (!state) return;

    const body = document.body;

    body.classList.remove(
      'atlas-ui-idle',
      'atlas-ui-loading',
      'atlas-ui-listening',
      'atlas-ui-thinking',
      'atlas-ui-offline',
      'atlas-ui-error'
    );

    body.classList.add('atlas-ui-' + state);
  });

})();
